// extracted by mini-css-extract-plugin
export default {"host":"PageContent_host__bVS8G"};